"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularProgress = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Color_1 = require("../../styles/Color");
exports.CircularProgress = () => {
    const useStyles = core_1.makeStyles({
        inProcessIndicator: {
            color: Color_1.Color[Color_1.ColorName.GREEN_TREEZ],
            zIndex: 1,
            padding: '11px',
        }
    });
    const { inProcessIndicator } = useStyles();
    return (react_1.default.createElement(core_1.CircularProgress, { size: 20, className: inProcessIndicator }));
};
exports.default = exports.CircularProgress;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2lyY3VsYXJQcm9ncmVzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9mZWVkYmFjay9sb2FkaW5nL0NpcmN1bGFyUHJvZ3Jlc3MudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUU2RDtBQUM3RCw0Q0FHeUU7QUFDekUsOENBRzBEO0FBRTdDLFFBQUEsZ0JBQWdCLEdBQXNCLEdBQUcsRUFBRTtJQUNwRCxNQUFNLFNBQVMsR0FBRyxpQkFBVSxDQUFDO1FBQ3pCLGtCQUFrQixFQUFFO1lBQ2hCLEtBQUssRUFBRSxhQUFLLENBQUMsaUJBQVMsQ0FBQyxXQUFXLENBQUM7WUFDbkMsTUFBTSxFQUFFLENBQUM7WUFDVCxPQUFPLEVBQUUsTUFBTTtTQUNsQjtLQUNKLENBQUMsQ0FBQztJQUVILE1BQU0sRUFBRSxrQkFBa0IsRUFBRSxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBRTNDLE9BQU8sQ0FDSCw4QkFBQyx1QkFBbUIsSUFBQyxJQUFJLEVBQUksRUFBRSxFQUFFLFNBQVMsRUFBSyxrQkFBa0IsR0FBSyxDQUN6RSxDQUFDO0FBQ04sQ0FBQyxDQUFBO0FBRUQsa0JBQWUsd0JBQWdCLENBQUMifQ==